import { createInstance } from './config';

const BASE_URL = '/unprotected';
// /api/unprotected/fields/:id
export const getById = async (id) => {
  const axios = await createInstance();
  const { data } = await axios.get(`${BASE_URL}/fields/${id}`);
  return data;
};
